import 'web-bluetooth';
const ACC_SERVICE = 'b6227000-9f03-11eb-a8b3-0242ac130003';
const ACCELERATION_CHARACTERISTIC = 'b6227001-9f03-11eb-a8b3-0242ac130003';
const X_CHARACTERISTIC = 'b6227002-9f03-11eb-a8b3-0242ac130003';
const Y_CHARACTERISTIC = 'b6227003-9f03-11eb-a8b3-0242ac130003';
const Z_CHARACTERISTIC = 'b6227004-9f03-11eb-a8b3-0242ac130003';
function checkBluetoothSupported() {
    return navigator.bluetooth ? true : false;
}
async function checkBluetoothAvailable() {
    var _a;
    return (_a = (await navigator.bluetooth.getAvailability())) !== null && _a !== void 0 ? _a : false;
}
function arrayBufferToString(buffer) {
    return String.fromCharCode.apply(null, new Uint8Array(buffer));
}
export class Accelerometer {
    constructor() {
        this.device = null;
        this.refreshRate = 1000 / 52;
    }
    async connect() {
        this.device = await navigator.bluetooth.requestDevice({
            filters: [{ namePrefix: 'CM' }, { services: [ACC_SERVICE] }],
        });
        this.device.gatt.connect();
    }
    async getAcceleration() {
        const service = await this.device.gatt.getPrimaryService(ACC_SERVICE);
        const characteristic = await service.getCharacteristic(ACCELERATION_CHARACTERISTIC);
        const value = arrayBufferToString((await characteristic.readValue()).buffer);
        return parseFloat(value);
    }
    async startAccelerometer(callback) {
        this.device.gatt.connect();
        const service = await this.device.gatt.getPrimaryService(ACC_SERVICE);
        const characteristic = await service.getCharacteristic(ACCELERATION_CHARACTERISTIC);
        characteristic.addEventListener('characteristicvaluechanged', (event) => {
            const target = event.target;
            const value = arrayBufferToString(target.value.buffer);
            callback(parseFloat(value));
        });
        characteristic.startNotifications();
    }
    disconnect() {
        return this.device.gatt.disconnect();
    }
}
